<div class="animation-container pb-7">
    <ng-container *ngIf="currentAnimation">
        <div class="lottie-wrapper d-flex justify-content-center">
            <app-lottie-animation 
                [animationData]="animations[currentAnimation].data" 
                [animationName]="currentAnimation" 
                [autoplay]="true"
                [loop]="false"
            >
            </app-lottie-animation>
        </div>
        <div class="status-info px-4">
            <p class="title my-3">{{ animations[currentAnimation].title }}</p>
            <p class="description">{{ animations[currentAnimation].description }}</p>
        </div>
    </ng-container>

    <div
        class="button-container w-100 mt-auto px-4 fixed-bottom"
        *ngIf="currentStep === TokenizationFlowStep.SUCCESS"
    >
        <div class="row w-100 mx-auto mb-4">
            <button
                type="submit"
                class="cc-submit-btn w-100"
                mat-flat-button
                (click)="submitGoHomeApp()"
            >
                Continuar
            </button>
        </div>
    </div>
</div>